import BlockModel from '@wre/infinity-generators/SchemeOfLearning/Year4/Summer/DecimalsB/index';
import { newBlockContent } from '../../../Block';
import { newSmallStepContent } from '../../../SmallStep';

const Block = newBlockContent({
  block: 'DecimalsB',
  field: 'Number',
  weeks: [1, 2],
  smallSteps: [
    // Step 1
    newSmallStepContent({
      ...BlockModel.smallSteps[0],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Summer/DecimalsB/1MakeAWholeWithTenths" */ './1MakeAWholeWithTenths'
        )
    }),
    // Step 2
    newSmallStepContent({
      ...BlockModel.smallSteps[1],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Summer/DecimalsB/2MakeAWholeWithHundredths" */ './2MakeAWholeWithHundredths'
        )
    }),
    // Step 3
    newSmallStepContent({
      ...BlockModel.smallSteps[2],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Summer/DecimalsB/3PartitionDecimals" */ './3PartitionDecimals'
        )
    }),
    // Step 4
    newSmallStepContent({
      ...BlockModel.smallSteps[3],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Summer/DecimalsB/4FlexiblyPartitionDecimals" */ './4FlexiblyPartitionDecimals'
        )
    }),
    // Step 5
    newSmallStepContent({
      ...BlockModel.smallSteps[4],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Summer/DecimalsB/5CompareDecimals" */ './5CompareDecimals'
        )
    }),
    // Step 6
    newSmallStepContent({
      ...BlockModel.smallSteps[5],
      module: () =>
        import(/* webpackChunkName: "Year4/Summer/DecimalsB/6OrderDecimals" */ './6OrderDecimals')
    }),
    // Step 7
    newSmallStepContent({
      ...BlockModel.smallSteps[6],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Summer/DecimalsB/7RoundToTheNearestWholeNumber" */ './7RoundToTheNearestWholeNumber'
        )
    }),
    // Step 8
    newSmallStepContent({
      ...BlockModel.smallSteps[7],
      module: () =>
        import(
          /* webpackChunkName: "Year4/Summer/DecimalsB/8HalvesAndQuartersAsDecimals" */ './8HalvesAndQuartersAsDecimals'
        )
    })
  ]
});
export default Block;
